import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
/**
 * BO'LINMA — korxona (yoki MTU apparati) ichidagi bo'lim.
 *
 * `org_unit` daraxtidan ATAYLAB ajratilgan: u DTIL dan import qilinadi va
 * qayta importda qo'lda yaratilgan satrlar yo'qolardi. Bo'linmani esa
 * adminlar o'zi yaratadi.
 *
 * Nom TAKRORLANADI — «R va AX» ham Qarshi MTU apparatida, ham uning
 * ichidagi SHCH-8 da bo'lishi mumkin. Unikallik shu sababli global emas,
 * `(orgUnitId, code)` juftligi bo'yicha.
 */
const idRef = z.string().regex(/^\d+$/, 'Identifikator raqamlardan iborat bo\'lishi kerak');
const codeSchema = z
    .string()
    .regex(/^[A-Za-z0-9][A-Za-z0-9._-]{0,39}$/, 'Kod harf/raqam bilan boshlanib, 40 belgidan oshmasligi kerak');
export const subdivisionSchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    orgUnitId: z.string(),
    /** Egasining nomi — ro'yxatda bo'linma YOLG'IZ ko'rsatilmaydi. */
    orgUnitName: z.string(),
    /**
     * Egasining rasmiy belgisi — «MTU-5», «PCH-70».
     *
     * Nomning O'ZI yetarli emas: tuzilmada bir xil nomli ikki yozuv bo'ladi
     * (MTU ning o'zi va uning apparati). Faqat nom ko'rsatilganda ular
     * ekranda aynan bir xil ikki qator bo'lib chiqadi va bo'lim qaysi biriga
     * biriktirilgani bilinmaydi.
     */
    orgUnitCode: z.string(),
    mtuId: z.string().nullable(),
    isActive: z.boolean(),
});
export const createSubdivisionSchema = z.object({
    code: codeSchema,
    name: z.string().min(2, 'Nom kamida 2 belgidan iborat bo\'lsin').max(200),
    /** Egasi — korxona yoki MTU. Haqiqiy tekshiruv shu ustun bo'yicha. */
    orgUnitId: idRef,
    /**
     * Faqat `@ScopeTarget` uchun e'lon qilingan NIYAT (`createOrgUnitSchema`
     * bilan ayni naqsh): MTU doirasidagi xodimning ruxsati shu qiymatga
     * qarab tekshiriladi. SAQLANADIGAN `mtuId` esa har doim egasidan
     * hisoblanadi — noto'g'ri niyat aytilsa, xizmat egani doira bilan o'qiy
     * olmay 404 beradi.
     */
    mtuId: idRef.nullable().optional(),
});
export const updateSubdivisionSchema = z.object({
    name: z.string().min(2).max(200).optional(),
    isActive: z.boolean().optional(),
});
export const subdivisionQuerySchema = paginationQuerySchema.extend({
    orgUnitId: idRef.optional(),
    mtuId: idRef.optional(),
    search: z.string().max(200).optional(),
    /** Xodim biriktirishda faqat FAOL bo'linmalar kerak. */
    activeOnly: z.coerce.boolean().optional(),
});
/**
 * BO'LINMA QOLDIG'INING harakat turlari.
 *
 * Ro'yxat TO'LIQ e'lon qilinadi, garchi 1-bosqichda faqat `IN` yozilsa ham:
 * jurnal jadvalidagi `CHECK` shu ro'yxatdan quriladi va keyingi bosqichda
 * migratsiya emas, faqat kod qo'shiladi. Ro'yxat ikki joyda yozilsa
 * (`movement.ts` dagi qoidaning o'zi), ular bir kun ajralib ketardi.
 *
 *   IN           — talabnoma qabul qilindi, bo'linmaga tushdi
 *   WRITE_OFF    — ishlatildi / yaroqsiz bo'ldi (2-bosqich)
 *   RETURN       — asosiy omborga qaytarildi (2-bosqich)
 *   TRANSFER_OUT — boshqa bo'linmaga berildi (2-bosqich)
 *   TRANSFER_IN  — boshqa bo'linmadan olindi (2-bosqich)
 */
export const SUBDIVISION_MOVEMENT_TYPES = [
    'IN',
    'WRITE_OFF',
    'RETURN',
    'TRANSFER_OUT',
    'TRANSFER_IN',
    /* Lot boshqa ombor yoki zonaga ko'chdi — miqdor o'zgarmaydi. */
    'MOVE',
    /* Xodim javondan ishlatishga oldi (mobil ilova) — hisobdan chiqmaydi. */
    'USE',
    /*
     * YOZUVNING O'ZI xato bo'lgan — boshlang'ich qoldiq bekor qilindi.
     *
     * Qolganlaridan birortasi mos kelmaydi: `RETURN` — omborga
     * qaytarildi, `WRITE_OFF` — ishlatildi yoki yaroqsiz bo'ldi. Bu
     * yerda esa mol qayoqqa ham ketmagan. Jurnal o'zgarmas, shuning
     * uchun bekor qilish yozuvni o'chirmaydi — qarshi yozuv qo'yadi.
     */
    'CORRECTION',
];
export const subdivisionMovementTypeSchema = z.enum(SUBDIVISION_MOVEMENT_TYPES);
export const isSubdivisionMovementType = (value) => SUBDIVISION_MOVEMENT_TYPES.includes(value);
/**
 * Bo'linma qoldig'ining bitta satri.
 *
 * Partiya bo'yicha guruhlanadi (nomenklatura bo'yicha emas): bo'limdagi
 * qo'lqopning ham partiya raqami, kelgan sanasi va qaysi talabnoma bilan
 * kelgani ko'rinib turishi kerak — 2-bosqichda uni aynan shu partiya bo'lib
 * omborga qaytarish mumkin bo'ladi.
 */
export const subdivisionStockRowSchema = z.object({
    /** LOT — qoldiqning birligi: bitta talabnoma bilan kelgan bitta partiya. */
    lotId: z.string(),
    /** Etiketkadagi kod (`L7K2M9XQ4TD`) — skaner va qidiruv shu bilan ishlaydi. */
    code: z.string(),
    storeroomId: z.string(),
    storeroomName: z.string(),
    zoneId: z.string().nullable(),
    zoneName: z.string().nullable(),
    /** Javonda turgan miqdor — ishlatishga olinganlari ayrilgan. */
    shelfQty: z.number(),
    batchId: z.string(),
    batchNo: z.string(),
    nomenclatureId: z.string(),
    nomenclatureName: z.string(),
    unit: z.string(),
    qty: z.number(),
    /**
     * Kutilayotgan rasxod aktlaridagi miqdor.
     *
     * Kartochkada «3 dona (1 tasi rasxodda)» bo'lib chiqadi va rasxod
     * oynasining yuqori chegarasini beradi. Alohida ustunda saqlanmaydi —
     * `write_off_act` dan hisoblanadi, ya'ni haqiqat bitta joyda qoladi.
     */
    pendingWriteOffQty: z.number(),
    /** Eng oxirgi kirim — "qachondan beri turibdi" savoliga javob. */
    receivedAt: z.string(),
    /** Oxirgi kirimning talabnomasi va uni olib kelgan xodim. */
    requisitionId: z.string().nullable(),
    requisitionDocNo: z.string().nullable(),
    receivedByName: z.string().nullable(),
});
export const subdivisionStockQuerySchema = paginationQuerySchema.extend({
    search: z.string().max(200).optional(),
    storeroomId: z.string().regex(/^\d+$/).optional(),
});
/**
 * BO'LINMA JURNALINING bitta satri — «nima, qachon, qaysi hujjat bilan».
 *
 * Qoldiqdan farqi vaqtda: qoldiq HOZIRNI ko'rsatadi ("nima bor"), jurnal
 * esa O'TMISHNI ("nima kelgan"). Ikkalasi bir jadvalga sig'maydi — nolga
 * tushgan mahsulot qoldiqdan chiqib ketadi, lekin jurnalda qoladi va
 * "o'tgan oy nima olgandik?" degan savolga javob faqat shu yerda bor.
 *
 * `type` 2-bosqich uchun ham tayyor (hisobdan chiqarish, qaytarish,
 * o'tkazish): jadval bitta va yangi tur qo'shilganda ekran o'z-o'zidan
 * uni ham ko'rsatadi.
 */
export const subdivisionMovementRowSchema = z.object({
    id: z.string(),
    type: subdivisionMovementTypeSchema,
    qty: z.number(),
    unit: z.string(),
    nomenclatureId: z.string(),
    nomenclatureName: z.string(),
    batchId: z.string(),
    batchNo: z.string(),
    /** Hujjat turi (`REQUISITION`, ...) va uning raqami — topilsa. */
    docType: z.string(),
    docId: z.string().nullable(),
    docNo: z.string().nullable(),
    performedAt: z.string(),
    performedByName: z.string().nullable(),
    reason: z.string().nullable(),
});
export const subdivisionMovementQuerySchema = paginationQuerySchema;
/**
 * «MENING OMBORIM» sarlavhasi — bo'linma va uning qisqacha holati.
 *
 * Ko'rsatkichlar javob bilan BIRGA keladi: ular jadvalning o'zidan
 * hisoblanmaydi, chunki jadval sahifalangan va birinchi sahifadagi o'n
 * satrdan "nechta nom bor" degan savolga javob chiqmaydi. Ikki manba bo'lsa,
 * ular bir kun ikki xil son ko'rsatardi.
 */
export const mySubdivisionSchema = subdivisionSchema.extend({
    /** Qoldiqda nechta SATR bor (partiya bo'yicha) — `qty > 0` bo'lganlari. */
    itemCount: z.number().int().nonnegative(),
    /** Eng oxirgi kirim sanasi; hech narsa kelmagan bo'lsa `null`. */
    lastReceivedAt: z.string().nullable(),
});
/* ------------------------------------------------------------------ */
/* «MENING OMBORIM» STATISTIKASI                                       */
/* ------------------------------------------------------------------ */
/**
 * Panelda ko'rsatiladigan ro'yxatlarning UZUNLIGI.
 *
 * Shartnomada turadi, chunki uni IKKI tomon biladi: server shuncha satr
 * qaytaradi, ekran esa «yana N ta» yozuvini shu songa qarab chizadi.
 */
export const SUBDIVISION_STATS_PREVIEW = 5;
/**
 * KAM QOLGAN mahsulot.
 *
 * Chegara KATALOGDAN keladi (`nomenclature.min_stock`) — bo'linma uchun
 * alohida sozlama YO'Q. Sabab: markaziy ombor ham aynan shu songa
 * qaraydi va ikkinchi chegara qo'yilsa, bir xil mahsulot ikki joyda ikki
 * xil «kam» bo'lib qolardi. Chegarasi nol bo'lgan mahsulot umuman
 * ogohlantirmaydi: nol — «chegara qo'yilmagan» degani.
 */
export const subdivisionLowStockSchema = z.object({
    nomenclatureId: z.string(),
    name: z.string(),
    unit: z.string(),
    qty: z.number(),
    minStock: z.number(),
});
/** Ishlatish yozuvi — «kim, nimani, qancha, qachon». */
export const subdivisionUseSchema = z.object({
    nomenclatureId: z.string(),
    name: z.string(),
    unit: z.string(),
    qty: z.number(),
    byName: z.string().nullable(),
    at: z.string(),
});
/** Eng ko'p ishlatilgan mahsulot — davr ichidagi yig'indi bilan. */
export const subdivisionTopUsedSchema = z.object({
    nomenclatureId: z.string(),
    name: z.string(),
    unit: z.string(),
    qty: z.number(),
});
/**
 * «MENING OMBORIM» ning yuqori paneli.
 *
 * Ko'rsatkichlar SERVERDA hisoblanadi, jadvaldan emas: jadval
 * sahifalangan va birinchi sahifadagi o'n satrdan «nechtasi kam qoldi»
 * degan savolga javob chiqmaydi. Ikki manba bo'lsa, ular bir kun ikki xil
 * son ko'rsatardi.
 *
 * Ro'yxatlar QISQA (`SUBDIVISION_STATS_PREVIEW`): panel javob emas, yo'l
 * ko'rsatkichi — to'liq ro'yxat o'z bo'limida turadi.
 */
export const subdivisionStatsSchema = z.object({
    /** Qoldiqda nechta NOM bor (satr emas, nom). */
    itemCount: z.number().int().nonnegative(),
    /** Chegarasidan pastga tushgan nomlar soni va ulardan namunasi. */
    lowCount: z.number().int().nonnegative(),
    lowStock: z.array(subdivisionLowStockSchema),
    /** Bo'linmaga kelgan, lekin hozir NOLGA tushgan nomlar soni. */
    outCount: z.number().int().nonnegative(),
    lastReceivedAt: z.string().nullable(),
    /** Nechta KIRIM hujjati bo'lgan — «bir marta keldi» degan savolga javob. */
    receiptCount: z.number().int().nonnegative(),
    lastUse: subdivisionUseSchema.nullable(),
    /** Oxirgi 30 kunda eng ko'p sarflanganlar. */
    topUsed: z.array(subdivisionTopUsedSchema),
});
/* ------------------------------------------------------------------ */
/* OMBOR (bo'linma ichidagi saqlash joyi) va ZONA                      */
/* ------------------------------------------------------------------ */
const nameField = z.string().trim().min(1).max(120);
export const storeroomZoneSchema = z.object({
    id: z.string(),
    name: z.string(),
    /** Zonada turgan (qoldig'i bor) lotlar soni — o'chirish tugmasi shunga qaraydi. */
    lotCount: z.number().int().nonnegative(),
});
export const storeroomSchema = z.object({
    id: z.string(),
    subdivisionId: z.string(),
    name: z.string(),
    purpose: z.string().nullable(),
    responsibleUserId: z.string().nullable(),
    responsibleName: z.string().nullable(),
    isActive: z.boolean(),
    lotCount: z.number().int().nonnegative(),
    zones: z.array(storeroomZoneSchema),
    /** Joriy xodim shu omborning mas'ulimi — boshqarish tugmalari shunga qaraydi. */
    canManage: z.boolean(),
});
export const createStoreroomSchema = z.object({
    name: nameField,
    purpose: z.string().trim().max(300).nullish(),
    zones: z.array(nameField).max(50).optional(),
});
export const updateStoreroomSchema = z
    .object({
    name: nameField.optional(),
    purpose: z.string().trim().max(300).nullable().optional(),
    isActive: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: "O'zgartirish yo'q" });
export const storeroomZoneInputSchema = z.object({ name: nameField });
/** Lotni boshqa ombor yoki zonaga ko'chirish — lot butunligicha ko'chadi. */
export const moveLotSchema = z.object({
    storeroomId: z.string().regex(/^\d+$/),
    zoneId: z.string().regex(/^\d+$/).nullable(),
});
/**
 * QABUL JOYI — talabnoma qabul qilinayotganda har bir partiya qaysi ombor
 * va zonaga tushishi. Ko'rsatilmagan partiya bo'linmaning birinchi faol
 * omboriga tushadi (yo'q bo'lsa «Asosiy ombor» yaratiladi).
 */
export const receiptPlacementSchema = z.object({
    batchId: z.string().regex(/^\d+$/),
    storeroomId: z.string().regex(/^\d+$/),
    zoneId: z.string().regex(/^\d+$/).nullable(),
    /**
     * SHU joyga tushadigan miqdor — bitta mahsulotni bo'lish uchun.
     *
     * Kelgan o'nta paneldan oltitasi garajga, to'rttasi seyfga tushishi
     * haqiqiy hol va ilgari buning yo'li umuman yo'q edi: bitta partiya
     * bo'linmada bitta lot bo'lardi, ko'chirish ham BUTUN lotni
     * ko'chirardi.
     *
     * Berilmasa (`null`) — o'sha partiyaning HAMMASI shu joyga tushadi.
     * Bitta partiya uchun bir nechta joy berilgan bo'lsa, oxirgisining
     * miqdori qoldiqdan hisoblanadi: yig'indi kelgan miqdorga aynan teng
     * bo'lishi shart va uni mijozga sanatib qo'yish xatoga olib borardi.
     */
    qty: z.number().positive().max(1_000_000).nullish(),
});
//# sourceMappingURL=subdivision.js.map